import { welcomeMessage, initThread } from './_chatWidget.js';
import { animations } from './_animations.js';


document.addEventListener('DOMContentLoaded', () => {
    
    const form = document.getElementById('documentForm');
    let sessionId = crypto.randomUUID();
   


    animations();
    welcomeMessage(sessionId);

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        initThread(sessionId);
    });
});
